export const environment = {
  production: false,
  appVersion: 'beta',
  beServiceUrl: 'https://be-cot-dev.regione.abruzzo.it/api',
  ehrServerUrl: 'https://ehr-cot-dev.regione.abruzzo.it/rest/v1/',
  keycloak: {
    url: 'https://keycloak-cot-dev.regione.abruzzo.it',
    realm: 'cot',
    clientId: 'cot_dashboard',
  }
};
